<template>
  <div class="inv-link">
    <div class="il-head">
      <i class="fas fa-link"></i>
      <span>Invitation link</span>
      <small v-if="expiresAt">valid until {{ niceDate(expiresAt) }}</small>
    </div>
    <div class="il-box">
      <input ref="input" type="text" readonly :value="link" @focus="$event.target.select()" aria-label="Invitation link">
      <button type="button" class="il-copy" :class="{ done: copied }" @click="copyLink">
        <i class="fas" :class="copied ? 'fa-check' : 'fa-copy'"></i> {{ copied ? 'Copied' : 'Copy' }}
      </button>
    </div>
    <p class="il-note">
      The email was sent{{ email ? ` to ${email}` : '' }}. You can also share this link another way (a message, a call):
      it works once, only for this person, and choosing a password with it activates the account.
    </p>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard';

export default {
  name: 'InvitationLink',
  props: {
    link: { type: String, required: true },
    email: { type: String, default: '' },
    expiresAt: { type: String, default: '' },
  },
  data() {
    return { copied: false, timer: null };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    niceDate(d) { return new Date(d).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); },
    copyLink() {
      copy(this.link);
      this.copied = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.copied = false; }, 2200);
    },
  },
};
</script>

<style scoped lang="scss">
.inv-link {
  padding: 14px;
  border-radius: 14px;
  background: rgba(var(--accent-green-rgb), 0.08);
  border: 1px solid rgba(var(--accent-green-rgb), 0.3);
}

.il-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-weight: 800;
  font-size: 0.86rem;
  color: var(--text-heading);
  i { color: var(--accent-green); }
  small { font-weight: 600; color: var(--text-muted); }
}

.il-box {
  display: flex;
  gap: 8px;
  margin-top: 8px;

  input {
    flex: 1;
    min-width: 0;
    height: 38px;
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid var(--border-color);
    background: var(--bg-secondary);
    color: var(--text-main);
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.78rem;
  }
}

.il-copy {
  flex: none;
  height: 38px;
  padding: 0 14px;
  border: 0;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.84rem;
  color: #fff;
  background: var(--accent-gradient);
  transition: transform 0.15s;
  &:hover { transform: translateY(-1px); }
  &.done { background: #159895; }
}

.il-note { margin: 8px 0 0; font-size: 0.74rem; color: var(--text-muted); }
</style>
